import { parseResponse } from '@tableau/metrics-engine';

import { Messages } from '~src/codegen/Localize';
import { ListResult } from '~src/httpClient/fetchers/ListResult';
import { BaseParamsBuilderResourceQuery } from '~src/httpClient/resources/ResourceQuery';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { IMetricInfo } from '~src/metrics/models/IMetricInfo';

import { GetWorkbookUsageMetricsRequest, GetWorkbookUsageMetricsResult } from '../requests/GetWorkbookUsageMetricsRequest';
import { IMetricDataPoints } from './../../metrics/serverApi/types/IMetricDataList';

export class WorkbookUsageMetricsResourceQuery extends BaseParamsBuilderResourceQuery<IMetricInfo> {
  /**
   * Helper method for building usage metric info
   */
  private metricItemMapper(dataPoints: IMetricDataPoints, id: string, workbookId: string): IMetricInfo {
    let name = '';
    let description = '';
    switch (id) { // id is hardcoded in BE implementation
      case 'totalViews':
        name = Messages.workbookUsageTotalViewsTitle();
        description = Messages.workbookUsageTotalViewsDescription();
        break;
      case 'totalFavorites':
        name = Messages.workbookUsageTotalFavoritesTitle();
        description = Messages.workbookUsageTotalFavoritesDescription();
        break;
      case 'totalShares':
        name = Messages.workbookUsageTotalSharesTitle();
        description = Messages.workbookUsageTotalSharesDescription();
        break;
    }

    return {
      connectedView: null,
      contentType: 'metric',
      createdAt: null,
      updatedAt: null,
      favorite: false,
      tags: [],
      id,
      name,
      description,
      dataPointsApiResponse: parseResponse(dataPoints).unwrap(),
      isUsageMetric: true,
      workbookId
    };
  }

  /**
   * Method to fetch workbook usage metrics. There are only 2 such metrics for now so start and size params are ignored.
   */
  public getSlice(start: number, size: number): Promise<ListResult<IMetricInfo>> {
    const requestParams = this.getExtraParams();
    return WebHttpClient.sendRequest(new GetWorkbookUsageMetricsRequest(requestParams))
      .then((result: GetWorkbookUsageMetricsResult) => {
        if (result.errors) {
          return new ListResult([], 0, 0, result.errors);
        }

        const items: IMetricInfo[] = [];
        for (let key in result.data) {
          items.push(this.metricItemMapper(result.data[key], key, requestParams.workbookId));
        }
        return new ListResult(items, 0, items.length);
      })
      .catch((errorCode) => {
        return new ListResult([], 0, 0, [{ code: errorCode }]);
      });
  }

  /**
   * Method to satisfy BaseParamsBuilderResourceQuery class definition. Not used.
   */
  public getCount(): Promise<number> {
    return this.getSlice(0, 0).then((slice: ListResult<IMetricInfo>) => slice.total);
  }
  /**
   * Method to satisfy BaseParamsBuilderResourceQuery class definition. Not used.
   */
  public getFirst(): Promise<IMetricInfo> {
    return this.getSlice(0, 0).then((slice: ListResult<IMetricInfo>) => slice.items[0]);
  }
}
